(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_9dd0286"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reincarvation-photo-promo')) {
    customElements.define('reincarvation-photo-promo', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();

        const options = { signal: this.controller.signal };

        this.formDialog = this.querySelector('[data-photo-form]');
        this.successDialog = this.querySelector('[data-photo-success]');

        this.setupFormStyling();
        this.setupFreeReferral(options);

        this.querySelector('[data-photo-open]')?.addEventListener(
          'click',
          () => this.openDialog(this.formDialog),
          options
        );

        this.querySelectorAll('[data-photo-close]').forEach(button => {
          button.addEventListener(
            'click',
            () => button.closest('dialog').close(),
            options
          );
        });

        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('close', () => this.restorePage(), options);

          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;

            const rect = dialog.getBoundingClientRect();

            if (
              event.clientX < rect.left ||
              event.clientX > rect.right ||
              event.clientY < rect.top ||
              event.clientY > rect.bottom
            ) {
              dialog.close();
            }
          }, options);
        });

        const url = new URL(window.location.href);

        if (url.searchParams.get('photo-received') === '1') {
          this.openDialog(this.successDialog);
          url.searchParams.delete('photo-received');

          window.history.replaceState(
            window.history.state,
            '',
            url.pathname + url.search + url.hash
          );
        }

        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) {
            this.openDialog(this.formDialog);
          }
        }, options);
      }

      setupFreeReferral(options) {
        const dialog = this.querySelector('[data-referral-dialog]');
        if (!dialog) return;

        const requestForm = dialog.querySelector('form');
        const signup = dialog.querySelector('[data-referral-signup]');
        const pending = dialog.querySelector('[data-referral-pending]');
        const share = dialog.querySelector('[data-referral-share]');
        const linkInput = dialog.querySelector('[data-referral-link]');
        const feedback = dialog.querySelector('[data-referral-feedback]');

        const requestKey = 'mhn-referral-request-' + requestForm.id;
        const codeKey = 'mhn-referral-issued-code';

        const safeGet = key => {
          try {
            return sessionStorage.getItem(key);
          } catch {
            return null;
          }
        };

        const safeSet = (key, value) => {
          try {
            sessionStorage.setItem(key, value);
          } catch {}
        };

        const safeRemove = key => {
          try {
            sessionStorage.removeItem(key);
          } catch {}
        };

        const setShare = code => {
          if (!/^RF-[A-Z0-9]{6,20}$/.test(code || '')) return false;

          const url = new URL(
            '/discount/' + encodeURIComponent(code),
            window.location.origin
          );

          url.searchParams.set('redirect', '/collections/all');
          linkInput.value = url.href;

          const message =
            'Thought you’d love these house numbers. Get $5 off an order of $30 or more: ' +
            url.href;

          dialog.querySelector('[data-referral-whatsapp]').href =
            'https://wa.me/?text=' + encodeURIComponent(message);

          dialog.querySelector('[data-referral-email]').href =
            'mailto:?subject=' +
            encodeURIComponent('A little something for your home') +
            '&body=' +
            encodeURIComponent(message);

          requestForm.hidden = true;
          share.hidden = false;
          feedback.textContent = '';

          safeSet(codeKey, code);

          return true;
        };

        this.querySelectorAll('[data-referral-open]').forEach(trigger => {
          trigger.addEventListener('click', event => {
            event.preventDefault();
            this.openDialog(dialog);
          }, options);
        });

        requestForm.addEventListener(
          'submit',
          () => safeSet(requestKey, '1'),
          options
        );

        dialog.querySelector('[data-referral-copy]').addEventListener('click', async () => {
          try {
            if (navigator.clipboard?.writeText) {
              await navigator.clipboard.writeText(linkInput.value);
            } else {
              linkInput.focus();
              linkInput.select();

              if (!document.execCommand('copy')) {
                throw new Error('copy failed');
              }
            }

            feedback.textContent = '✓ Link copied';
          } catch {
            linkInput.focus();
            linkInput.select();
            feedback.textContent = 'Select the link and copy it to share.';
          }
        }, options);

        dialog.querySelector('[data-referral-reset]').addEventListener('click', () => {
          safeRemove(codeKey);

          share.hidden = true;
          requestForm.hidden = false;
          signup.hidden = false;
          pending.hidden = true;

          requestForm.querySelector('input[type=email]')?.focus();
        }, options);

        const pageUrl = new URL(window.location.href);
        const issuedCode = pageUrl.searchParams.get('share_referral');
        const requested = safeGet(requestKey) === '1';
        const status = dialog.querySelector('[data-referral-post-status]').dataset.referralPostStatus;

        if (issuedCode && setShare(issuedCode)) {
          this.openDialog(dialog);

          pageUrl.searchParams.delete('share_referral');

          window.history.replaceState(
            window.history.state,
            '',
            pageUrl.pathname + pageUrl.search + pageUrl.hash
          );
        } else if (requested && (status === 'success' || status === 'error')) {
          safeRemove(codeKey);

          if (status === 'success') {
            safeRemove(requestKey);
          }

          this.openDialog(dialog);
        } else {
          setShare(safeGet(codeKey));
        }
      }

      setupFormStyling() {
        const fields = this.querySelector('[data-photo-fields]');
        if (!fields) return;

        const css = `
:host{
  --inline-container-max-width:100% !important;
  --container-max-w:100% !important;
  --form-background-color:transparent !important;
  --container-background-color:transparent !important;
  --form-field-border-radius:7px !important;
  --button-border-radius:100px !important;
  --forms-body-font:normal 400 15px Archivo,Arial,sans-serif !important;
  --forms-base-font-size:15px !important;
  --button-background-color:#141414 !important;
  --button-text-color:#fff !important;
  --form-placeholder-color:#827b73 !important;
  --form-text-color:#202020 !important;
  --form-field-border:0 0 0 1px #cec6bc !important;
  --form-field-border-focused:0 0 0 2px #575047 !important;
  --form-field-padding:14px !important;
  --form-field-padding-top:21px !important;
  --form-field-padding-bottom:7px !important;
}
[data-current-step="form"] [class*="_formHeader_"],
[data-current-step="form"] [class*="_formDisclaimer_"]{
  display:none !important;
}
[class*="_inline_"],
[class*="_formContainer_"],
[class*="_gridItemContent_"]{
  padding:0 !important;
  margin:0 !important;
  width:100% !important;
  max-width:none !important;
  background:transparent !important;
}
[class*="_formContainer_"]{
  display:block !important;
}
[class*="_gridItem_"]:not([class*="_gridItemContent_"]){
  display:none !important;
}
form[data-testid="form"]{
  display:grid !important;
  grid-template-columns:repeat(2,minmax(0,1fr)) !important;
  gap:12px !important;
  margin:0 !important;
  text-align:left !important;
}
form[data-testid="form"]>div:has(shop-lead-capture){
  display:none !important;
}
form[data-testid="form"]>*{
  grid-column:1 / -1;
  min-width:0;
}
form[data-testid="form"]>div:has(input[id="first_name"]){
  grid-column:1;
}
form[data-testid="form"]>div:has(input[id="email"]){
  grid-column:2;
}
[class*="_formInputField_"]{
  font-family:Archivo,Arial,sans-serif !important;
  min-height:48px !important;
  background:transparent !important;
  border-radius:7px !important;
}
[class*="_formFieldContainer_"]{
  margin:0 !important;
}
[class*="_formFileInput_"]>p{
  display:none !important;
}
[class*="_formFileInputField_"]{
  min-height:106px !important;
  border:1px dashed #bfb6aa !important;
  border-radius:9px !important;
  background:transparent !important;
  position:relative;
}
[class*="_formFileInputContent_"]{
  min-height:104px !important;
  display:flex !important;
  flex-direction:column !important;
  justify-content:center !important;
  align-items:center !important;
  gap:7px !important;
  padding:14px !important;
}
[class*="_formFileInputContent_"]::before{
  content:"";
  display:block;
  width:28px;
  height:28px;
  background:center/contain no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23171717' stroke-width='1.3'%3E%3Cpath d='M3 7h4l2-3h6l2 3h4v13H3z'/%3E%3Ccircle cx='12' cy='13' r='4'/%3E%3C/svg%3E");
}
[class*="_formFileInputButton_"]{
  background:transparent !important;
  border:0 !important;
  padding:0 !important;
  font:400 16px Archivo,Arial,sans-serif !important;
  color:#171717 !important;
}
fieldset[class*="_checkboxFieldSet_"]{
  border:0 !important;
  padding:0 !important;
  margin:0 !important;
  min-width:0;
}
fieldset[class*="_checkboxFieldSet_"]>legend{
  display:none !important;
}
[class*="_checkboxField_"]{
  align-items:flex-start !important;
  gap:10px !important;
}
[class*="_checkboxField_"] span{
  font:400 12px/1.5 Archivo,Arial,sans-serif !important;
}
button[data-testid="btn-form-submit"]{
  min-height:50px !important;
  margin:0 !important;
  width:100% !important;
  border-radius:100px !important;
  letter-spacing:.18em !important;
  font:500 12px/1.4 Archivo,Arial,sans-serif !important;
  background:#141414 !important;
  color:white !important;
  padding:14px 18px !important;
}
button[data-testid="btn-form-submit"]::after{
  content:" →";
  margin-left:10px;
}
@media(max-width:599px){
  form[data-testid="form"]{
    grid-template-columns:1fr !important;
  }
  form[data-testid="form"]>div:has(input[id="email"]){
    grid-column:1;
  }
  input{
    font-size:16px !important;
  }
}
`;

        this.formObservers = [];

        const attach = () => {
          const embed = fields.querySelector('shopify-forms-embed');
          const root = embed?.shadowRoot;

          if (!root) return false;

          if (this.photoPreviewRoot !== root) {
            this.photoPreviewRoot = root;

            let preview;
            let urls = [];

            const clearUrls = () => {
              urls.forEach(url => URL.revokeObjectURL(url));
              urls = [];
            };

            root.addEventListener('change', event => {
              const input = event.target;

              if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;

              clearUrls();
              preview?.remove();

              const files = Array.from(input.files || []);

              if (!files.length) return;

              preview = document.createElement('div');
              preview.setAttribute('role', 'status');
              preview.setAttribute('aria-live', 'polite');

              preview.style.cssText =
                'display:grid;gap:8px;grid-column:1/-1;margin:8px 0;font:12px Archivo,Arial,sans-serif;text-align:left';

              files.forEach((file, index) => {
                const row = document.createElement('div');

                row.style.cssText =
                  'display:flex;align-items:center;gap:12px;padding:10px;border:1px solid #d8d0c6;border-radius:8px;background:#ffffff66';

                if (file.type.startsWith('image/')) {
                  const image = document.createElement('img');
                  const url = URL.createObjectURL(file);

                  urls.push(url);

                  image.src = url;
                  image.alt = file.name;

                  image.style.cssText =
                    'width:52px;height:52px;object-fit:cover;border-radius:5px;flex-shrink:0';

                  row.appendChild(image);
                }

                const text = document.createElement('div');
                text.style.cssText = 'flex:1;min-width:0';

                const status = document.createElement('strong');
                status.textContent = '✓ Photo added';

                status.style.cssText =
                  'display:block;margin-bottom:4px;font-size:12px;font-weight:500';

                const name = document.createElement('span');
                name.textContent = file.name;

                name.style.cssText =
                  'display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#7b756f;font-size:11px';

                text.append(status, name);

                const remove = document.createElement('button');
                remove.type = 'button';
                remove.textContent = 'Remove';
                remove.setAttribute('aria-label', 'Remove ' + file.name);

                remove.style.cssText =
                  'padding:6px 0;border:0;background:transparent;color:#6d655d;text-decoration:underline;font:inherit;cursor:pointer;flex-shrink:0';

                remove.addEventListener('click', () => {
                  const remaining = new DataTransfer();

                  files.forEach((item, itemIndex) => {
                    if (itemIndex !== index) {
                      remaining.items.add(item);
                    }
                  });

                  input.files = remaining.files;

                  input.dispatchEvent(
                    new Event('change', {
                      bubbles: true,
                      composed: true
                    })
                  );
                });

                row.append(text, remove);
                preview.appendChild(row);
              });

              const field =
                input.closest('[class*="_formFileInput_"]') ||
                input.parentElement;

              field.insertAdjacentElement('afterend', preview);
            }, { signal: this.controller.signal });

            this.controller.signal.addEventListener('abort', () => {
              clearUrls();
              preview?.remove();
              this.photoPreviewRoot = null;
            }, { once: true });
          }

          const update = () => {
            const received =
              !!root.querySelector('[data-current-step="success"]') ||
              (
                !root.querySelector('form[data-testid="form"]') &&
                /PHOTO\s+RECEIVED/i.test(root.textContent || '')
              );

            this.formDialog.querySelectorAll(
              '[class$="__modal-title"], [class$="__reward"], [class$="__intro"], [class$="__footer"]'
            ).forEach(element => {
              element.style.display = received ? 'none' : '';
            });

            if (!root.querySelector('[data-reincarvation-form-style]')) {
              const style = document.createElement('style');
              style.setAttribute('data-reincarvation-form-style', '');

              style.textContent = css + `
form[data-testid="form"]>div:has(input[id="first_name"]){
  grid-column:1 !important;
  overflow:visible !important;
}
form[data-testid="form"]>div:has(input[id="email"]){
  grid-column:2 !important;
  overflow:visible !important;
}
form[data-testid="form"] input:not([type="checkbox"]):not([type="file"]){
  border:1px solid #cec6bc !important;
  box-shadow:none !important;
  border-radius:7px !important;
  outline-offset:2px !important;
}
[class*="_formInputFieldLabel_"]{
  background:transparent !important;
}
button[data-testid="btn-form-submit"]{
  grid-column:1 / -1 !important;
  grid-row:auto !important;
  width:min(100%,360px) !important;
  max-width:360px !important;
  display:flex !important;
  align-items:center !important;
  justify-content:center !important;
  text-align:center !important;
  justify-self:center !important;
  margin:2px auto 0 !important;
}
@media(max-width:599px){
  form[data-testid="form"]>div:has(input[id="email"]){
    grid-column:1 !important;
  }
}
:host{
  --form-field-padding:12px !important;
  --form-field-padding-top:16px !important;
  --form-field-padding-bottom:4px !important;
  --button-padding:12px !important;
}
form[data-testid="form"]{
  gap:10px !important;
}
form[data-testid="form"] input:not([type="checkbox"]):not([type="file"]){
  box-sizing:border-box !important;
  width:100% !important;
  height:40px !important;
  min-height:40px !important;
  max-height:40px !important;
  padding:16px 12px 4px !important;
  font-size:13px !important;
  line-height:18px !important;
}
[class*="_formFieldContainer_"]{
  min-height:40px !important;
}
[class*="_formInputFieldLabel_"]{
  font-size:12px !important;
  top:12px !important;
}
[class*="_formFileInputField_"]{
  box-sizing:border-box !important;
  min-height:78px !important;
}
[class*="_formFileInputContent_"]{
  box-sizing:border-box !important;
  min-height:76px !important;
  padding:10px !important;
  gap:4px !important;
}
[class*="_formFileInputContent_"]::before{
  width:22px;
  height:22px;
}
[class*="_formFileInputButton_"]{
  font-size:13px !important;
}
[class*="_checkboxField_"] span{
  font-size:11px !important;
  line-height:1.4 !important;
}
button[data-testid="btn-form-submit"]{
  box-sizing:border-box !important;
  display:block !important;
  justify-self:center !important;
  width:100% !important;
  max-width:none !important;
  height:42px !important;
  min-height:42px !important;
  padding:10px 16px !important;
  font-size:11px !important;
  margin:0 auto !important;
}
@media(max-width:599px){
  form[data-testid="form"] input:not([type="checkbox"]):not([type="file"]){
    font-size:16px !important;
  }
}
`;
style.textContent += `
:host{
  --forms-body-font:inherit !important;
  --forms-base-font-size:16px !important;
  --button-border-radius:6px !important;
}

form[data-testid="form"]{
  gap:12px !important;
  font-family:inherit !important;
}

form[data-testid="form"] input:not([type="checkbox"]):not([type="file"]){
  height:56px !important;
  min-height:56px !important;
  max-height:none !important;
  padding:22px 16px 8px !important;
  border:1px solid #8e8982 !important;
  border-radius:6px !important;
  background:#ffffff20 !important;
  color:#20201e !important;
  font-family:inherit !important;
  font-size:16px !important;
  line-height:22px !important;
}

[class*="_formInputField_"],
[class*="_formInputFieldLabel_"]{
  font-family:inherit !important;
}

[class*="_formFileInputField_"]{
  border:1px dashed #8e8982 !important;
  border-radius:6px !important;
  background:#ffffff20 !important;
}

[class*="_formFileInputContent_"]{
  min-height:100px !important;
  padding:16px !important;
  gap:8px !important;
}

[class*="_formFileInputButton_"]{
  font-family:inherit !important;
  font-size:14px !important;
  font-weight:400 !important;
  letter-spacing:.035em !important;
}

[class*="_checkboxField_"] span{
  font-family:inherit !important;
  font-size:12px !important;
  line-height:1.6 !important;
  color:#645e57 !important;
}

button[data-testid="btn-form-submit"]{
  height:auto !important;
  min-height:60px !important;
  margin:4px 0 0 !important;
  padding:16px 20px !important;
  border:1px solid #242320 !important;
  border-radius:6px !important;
  background:#242320 !important;
  color:#fff !important;
  font-family:inherit !important;
  font-size:13px !important;
  font-weight:400 !important;
  letter-spacing:.24em !important;
}

@media(max-width:599px){
  form[data-testid="form"] input:not([type="checkbox"]):not([type="file"]){
    height:52px !important;
    min-height:52px !important;
  }

  button[data-testid="btn-form-submit"]{
    min-height:54px !important;
    font-size:11px !important;
    letter-spacing:.16em !important;
  }
}
`;
              root.appendChild(style);
            }

            const submit = root.querySelector('button[data-testid="btn-form-submit"]');

            if (
              submit &&
              submit.getAttribute('aria-disabled') !== 'true' &&
              submit.textContent !== fields.dataset.submitLabel
            ) {
              submit.textContent = fields.dataset.submitLabel;
            }

            const upload = root.querySelector('[class*="_formFileInputButton_"]');

            if (upload && upload.textContent !== fields.dataset.uploadLabel) {
              upload.textContent = fields.dataset.uploadLabel;
            }
          };

          update();

          if (this.styledRoot !== root) {
            this.formObservers.forEach(observer => observer.disconnect());

            const observer = new MutationObserver(update);
            observer.observe(root, { childList: true, subtree: true });

            this.formObservers = [observer];
            this.styledRoot = root;
          }

          return true;
        };

        this.attachFormStyle = attach;
        attach();

        let attempts = 0;

        this.styleTimer = setInterval(() => {
          attempts++;

          if (attach() || attempts >= 120) {
            clearInterval(this.styleTimer);
            this.styleTimer = null;
          }
        }, 250);
      }

      openDialog(dialog) {
        if (!dialog || dialog.open) return;

        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;

        this.attachFormStyle?.();

        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';

        this.isLocked = true;
      }

      restorePage() {
        if (!this.isLocked) return;

        document.documentElement.style.overflow = this.previousOverflow;
        this.isLocked = false;

        if (this.previousFocus?.isConnected) {
          this.previousFocus.focus({ preventScroll: true });
        }
      }

      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());

        this.restorePage();
        clearInterval(this.styleTimer);

        this.formObservers?.forEach(observer => observer.disconnect());

        this.styledRoot = null;
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
